export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-slate-900 text-white relative overflow-hidden">
      {/* Watermark */}
      <div className="absolute inset-0 flex items-center justify-center opacity-5 pointer-events-none">
        <span className="text-9xl font-bold">REBORN</span>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Column 1 - About */}
          <div className="md:col-span-1">
            <img src="https://static.readdy.ai/image/559167c3f2f3505c4b7c1eaccde744d9/54c40221c067c562571a6d30c158173b.jpeg" alt="Reborn Barbershop" className="h-16 w-auto mb-4" />
            <p className="text-gray-400 mb-4 leading-relaxed">
              Premium barbering in Heidelberg Heights
            </p>
            <address className="not-italic text-white text-sm mb-3">
              27 Southern Rd<br />
              Heidelberg Heights VIC 3081<br />
              Australia
            </address>
            <a href="tel:0451279664" className="text-white hover:text-red-600 transition-colors flex items-center gap-2">
              <i className="ri-phone-fill"></i>
              <span>0451 279 664</span>
            </a>
            <a href="mailto:salimi.vic259@gmail.com" className="text-white hover:text-red-600 transition-colors flex items-center gap-2 mt-2">
              <i className="ri-mail-fill"></i>
              <span>salimi.vic259@gmail.com</span>
            </a>
          </div>

          {/* Column 2 - Quick Links */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">QUICK LINKS</h3>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('services')} className="text-gray-400 hover:text-white transition-colors">
                  Services
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('barbers')} className="text-gray-400 hover:text-white transition-colors">
                  Barbers
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('hours')} className="text-gray-400 hover:text-white transition-colors">
                  Hours
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('location')} className="text-gray-400 hover:text-white transition-colors">
                  Location
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('reviews')} className="text-gray-400 hover:text-white transition-colors">
                  Reviews
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('booking')} className="text-gray-400 hover:text-white transition-colors">
                  Book Now
                </button>
              </li>
            </ul>
          </div>

          {/* Column 3 - Follow Us */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">FOLLOW US</h3>
            <ul className="space-y-3">
              <li>
                <a href="https://www.instagram.com/re_born_barber_/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors">
                  <div className="w-10 h-10 bg-red-600 rounded-full flex items-center justify-center">
                    <i className="ri-instagram-line text-white"></i>
                  </div>
                  <span>Instagram</span>
                </a>
              </li>
              <li>
                <a href="https://www.google.com/maps/place/27+Southern+Rd,+Heidelberg+Heights+VIC+3081" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors">
                  <div className="w-10 h-10 bg-red-600 rounded-full flex items-center justify-center">
                    <i className="ri-google-fill text-white"></i>
                  </div>
                  <span>Google</span>
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4 - Newsletter */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">STAY UPDATED</h3>
            <p className="text-gray-400 text-sm mb-4">
              Get grooming tips and special offers
            </p>
            <div className="flex gap-2">
              <input 
                type="email" 
                placeholder="Your email"
                className="flex-1 px-4 py-3 bg-slate-800 border border-slate-700 rounded-lg text-white text-sm focus:outline-none focus:border-red-600"
              />
              <button className="w-12 h-12 bg-white rounded-full flex items-center justify-center hover:bg-red-600 transition-colors group">
                <i className="ri-arrow-right-line text-black group-hover:text-white text-xl"></i>
              </button>
            </div>
            <p className="text-gray-500 text-xs mt-2">We respect your privacy</p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            &copy; 2025 Reborn Barbershop. All rights reserved.
          </p>
          <p className="text-gray-500 text-sm">
            Heidelberg Heights, Victoria
          </p>
        </div>
      </div>
    </footer>
  );
}